import styles from '../styles.module.scss';
import { ScoreRadarChart } from './ScoreRadarChart';

type DataPoint = {
  chartTitle: string;
  data: React.ComponentProps<typeof ScoreRadarChart>['data'];
};
type Props = {
  dataPoints: DataPoint[];
};

export const MetricRadarCard: React.FC<Props> = ({ dataPoints }) => {
  return (
    <div className={styles.metricRadarCard}>
      <h3 className={styles.title}>全体のスコア</h3>
      <div className={styles.chartsContainer}>
        {dataPoints.map(({ chartTitle, data }) => (
          <ScoreRadarChart key={chartTitle} chartTitle={chartTitle} data={data} />
        ))}
      </div>
    </div>
  );
};
